// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__KpRTi","fileBtn":"File_fileBtn__3mx16","closeBtn":"File_closeBtn__11pUJ","fileSelected":"File_fileSelected__2Umwi","disabled":"File_disabled__Yt904"};